// @ts-ignore
import CountryQuery from 'country-query'

export const getVisitorInfo = async () => {
  return await fetch("https://www.cloudflare.com/cdn-cgi/trace")
    .then(response => response.text())
    .then(result => {
      const countryCodeExpression = /loc=([\w]{2})/;
      const userIPExpression = /ip=([\w\.]+)/;
      const ip = userIPExpression.exec(result);
      const countryCode = countryCodeExpression.exec(result);
      return {
        ip, countryCode
      }
    }).catch((err) => {
      console.log("request failed")
    })
}

export const getVisitorCurrencyRate = async (currencyCode: string) => {
  return await fetch(`https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@2024.6.19/v1/currencies/${currencyCode.toLowerCase()}.json`)
    .then((res) => res.json())
    .then((data) => {
      const { [currencyCode.toLowerCase()]: rate } = data.inr;
           return rate;
    })
}

export const getCurrencyFromCode = (currencyCode: string) => {
  let countryData = CountryQuery.find("currencies", currencyCode);
  if (countryData.length > 0) {
    countryData = countryData[0]
  }
  let currency = {
    code: currencyCode,
    name: countryData.currencies[currencyCode].name,
    symbol: countryData.currencies[currencyCode].symbol,
  }
  return currency
}